import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ComboFclty from "../../components/inputs/ComboFclty";

const FcltyDeptSearchBox = ({
                              searchParam,
                              setSearchParam = require,
                              updateList,
                              setCurrentPage
                            }) => {

  const onChangeFclty = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchFcltyNo: e.target.value};
    });

  };

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    setCurrentPage(1);
  };

  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}
        >
          <Row className={"justify-content-center"}>
            <Col md={12}>
              <Row className={"justify-content-around"}>
                <Col md={10}>
                  <Row className={"gy-2"}>
                    {/*<Col md={3}>*/}
                    <Col xxl={3} xl={4} lg={4} md={6}>
                      <ComboFclty
                          propOnChange={onChangeFclty}
                      />
                    </Col>

                  </Row>
                </Col>

                <Col md={2}
                     className={"text-center search-btn-container d-flex align-items-center justify-content-center"}>
                  <Button
                      type="submit"
                      className={"search-btn"}
                      style={{width: "100px"}}
                  >
                    검색
                  </Button>
                </Col>

              </Row>
            </Col>
          </Row>
        </Form>
      </>
  );
};

export default FcltyDeptSearchBox;
